import "./Loader.scss";
const Loader = () => {
    return (
        <div>
            <div id='fader' className='fade in'/>
            <div className='loader fade in'><div /><div /><div /><div /></div>
            <div className='loader-backdrop-sm fade in' />
            <div className='loader-backdrop fade in' />
            <div className='loader-text fade in'/>
            <div className='loader-word'> Saving in progress </div>
        </div>
    );
};
export default Loader;